import { render } from "./FacultyTimetableView.vue?vue&type=template&id=4e3f402a&scoped=true"
import script from "./FacultyTimetableView.vue?vue&type=script&lang=js"
export * from "./FacultyTimetableView.vue?vue&type=script&lang=js"

import "./FacultyTimetableView.vue?vue&type=style&index=0&id=4e3f402a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4e3f402a"

export default script